// extracted by mini-css-extract-plugin
export default {"title":"alamat-pemilik-properti_title__KtYP6","input-wrapper":"alamat-pemilik-properti_input-wrapper__WJaY1","info":"alamat-pemilik-properti_info__5d1-7"};